import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { miniTable } from "MODULES/shared/decorators";
import withSubscription from "MODULES/Subscription/withSubscription";
import { shortDateYY } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import PurchaseOrderLineItemStatusCell from "MODULES/shared/components/PurchaseOrderLineItemStatusCell";
import {
  DataTable,
  LinkedTableRow,
  CompanyName,
  LineItemQtyCell,
  NoteTooltip
} from "MODULES/shared/components";
import api from "APP_ROOT/api";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import { displayCost } from "MODULES/PurchaseOrders/shared/helpers";
import { ExchangeIcon } from "MODULES/PurchaseOrders/shared/ExchangeIcon";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import classNames from "classnames";
import { INVENTORIES } from "MODULES/inventories/constants";

const formatCost = value => {
  if (value >= 1000) {
    return `$${Math.floor(value).toLocaleString()}`;
  }
  return dollars(value);
};

export class Table extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        company: PropTypes.shape({ name: PropTypes.string }),
        buyer: PropTypes.shape({ full_name: PropTypes.string }),
        condition: PropTypes.string.isRequired,
        quantity: PropTypes.number.isRequired,
        cost: PropTypes.string,
        has_vendor_rma: PropTypes.bool
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired
  };

  link = (type, uuid) => {
    if (type === "PurchaseOrder") {
      return `/purchase-orders/${uuid}`;
    } else if (type === "Lot") {
      return `/lots/${uuid}`;
    } else if (type === "LotLineItem") {
      return `/lots/${uuid}`;
    }

    return null;
  };

  renderRow = (lineItem, i) => (
    <LinkedTableRow
      to={this.link(lineItem.type, lineItem.parent_uuid)}
      key={i}
      cancelled={lineItem.cancelled}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>
            <LineItemQtyCell lineItem={lineItem} />
            {i + 1}
          </div>
        </div>
      </td>
      <PurchaseOrderLineItemStatusCell lineItem={lineItem}>
        {lineItem.has_vendor_rma && (
          <NoteTooltip
            icon="fa-shield"
            placement="top"
            note="Vendor RMA"
            color="white"
          />
        )}
        {shortDateYY(lineItem.created_at)}
      </PurchaseOrderLineItemStatusCell>
      <td className="text-nowrap">
        <CompanyName flattenedCompany={lineItem} truncateAt={18} />
      </td>
      <td className="text-nowrap">
        {lineItem.buyer_name &&
          truncate(getFirstNameLastInitial(lineItem.buyer_name), 14)}
      </td>
      <td className="text-nowrap">
        {lineItem.serial_number || lineItem.expected_serial_number}
      </td>
      <td className="text-nowrap">
        {lineItem.condition && INVENTORIES.condition[lineItem.condition].abbrev}
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td className="text-center">
        <ExchangeIcon lineItem={lineItem} />
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-center">{lineItem.lead_time}</td>
      <td className="text-right">
        {displayCost(lineItem) && formatCost(displayCost(lineItem))}
      </td>
      <NoteTooltipTableCell
        note={[lineItem.internal_note, lineItem.external_note]
          .filter(n => n !== null && n !== "")
          .join(" | ")}
        className={classNames({ "link-muted": lineItem.cancelled })}
      />
    </LinkedTableRow>
  );

  render() {
    return (
      <DataTable.Mini loading={this.props.loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Vendor</th>
          <th>Buyer</th>
          <th>SN</th>
          <th>CD</th>
          <th className="text-center">EXCH</th>
          <th className="text-center">QTY</th>
          <th className="text-center">LT</th>
          <th className="text-right">Cost/Unit</th>
          <th>Note</th>
        </DataTable.Head>
        <DataTable.Body>
          {this.props.results.map(this.renderRow)}
        </DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.purchaseOrderAndLots.search(match.params.id, params)
);

export default withRouter(
  withResults(withSubscription("PurchaseOrderLineItem")(Table))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/PurchaseOrders/Table.jsx